export const authTokenKey = 'AUTH_TOKEN';
export const PERSISTED_CACHE_KEY = 'pad_cache';
export const SESSION_EXPIRED_FLAG_KEY = 'SESSION_EXPIRED_WARNING';
